import * as React from 'react';
import './index.css'

function EntryButton (props) {
	return <div className='btn-wrap' onClick={props.onClick}>
		{props.text}
	</div>
	
};

export default EntryButton;
